import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { getTenant, Tenant } from '@infuse/api/iam/tenant';

export const useTenant = () => {
  const fetchTenantId = ref<string | undefined>(undefined);

  const query = useQuery<Tenant>({
    queryKey: ['tenants', 'detail', fetchTenantId],
    enabled: () => !!fetchTenantId.value,
    queryFn: () => getTenant({ id: fetchTenantId.value })
  });

  const tenant = computed(() => query.data.value);

  return {
    ...query,
    tenant,
    fetchTenantId
  };
};
